import { gql } from '@/lib/graphql/gql'

export const CREATE_LOAD_BALANCER_QUERY = gql`
  query CreateLoadBalancerPage($idCompany: String!) {
    company(id: $idCompany) {
      id
      projects {
        id
        items {
          id
          displayName
        }
      }
    }
  }
`

export const CREATE_LOAD_BALANCER = gql`
  mutation CreateLoadBalancer(
    $idCompany: String!
    $idProject: String
    $idPipelineStage: String
    $type: EdgeLoadBalancerType!
    $displayName: String!
    $destinations: [EdgeLoadBalancerDestinationInput!]!
  ) {
    createEdgeLoadBalancer(
      idCompany: $idCompany
      idProject: $idProject
      type: $type
      idPipelineStage: $idPipelineStage
      displayName: $displayName
      destinations: $destinations
    ) {
      id
      name
    }
  }
`
